export default __webpack_public_path__ + "static/assets/1b1f10641683aca6c9af38dce0345916.png";